<template>
  <div class="container">
    
    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h1 class="titulo m-t-2 m-t-3-md">Transformaciones principales</h1>
      <hr>
      <p class="texto-principal">Las transformaciones hacen referencia a los procesos de transformación de energéticos en los que uno o varios energéticos primarios o secundarios se procesan para obtener uno o varios energéticos secundarios.</p>

      <h3>Petróleo</h3>

      <p class="texto-principal">El petróleo, el principal energético primario de nuestro país, es transformado en refinerías, complejos industriales encargados de transformar el petróleo crudo en distintos derivados por medio de una serie de procesos físicos y químicos que incluyen desintegración térmica y catalítica, destilación atmosférica y al vacío, alquilación y reformación catalítica, entre otros.</p>
      <p class="texto-principal">Los productos obtenidos de la refinación del petróleo son el coque de petróleo, combustóleo, queroseno, diésel, gasolina, gas licuado del petróleo, gas seco y otros productos no energéticos.</p>

    </div>

    <div>

      <div class="tarjeta-contenedor">
        <div class="encabezado">
          <h3>Transformaciones del petróleo</h3>
          <p class="texto-notas">Datos en peta joules (PJ). Año 2020.</p>
        </div>
        <div class="contenido">
          <div class="graficaRefinacion" ref="graficaRefinacion">
          </div>
        </div>
        <!--<div class="notas">
            <div class="contenedor"></div>
            <button class="boton-notas">Más información</button>
          </div>-->
      </div>

      </div>
      <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
        <h3>Electricidad</h3>
        <p class="texto-principal">La generación eléctrica es todo el conjunto de transformaciones que convierte distintos energéticos en energía eléctrica, a través de un amplio conjunto de tecnologías y energéticos. </p>
      </div>
      <div>
      <div class="tarjeta-contenedor">
        <div class="encabezado">
          <h3>Transformaciones de la electricidad</h3>
          <p class="texto-notas">Datos en peta joules (PJ). Año 2020.</p>
        </div>
        <div class="contenido">
          <div class="graficaGeneracionElectrica" ref="graficaGeneracionElectrica">
          </div>
        </div>
        <!--<div class="notas">
            <div class="contenedor"></div>
            <button class="boton-notas">Más información</button>
          </div>-->
      </div>

    </div>
    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h3>Otras transformaciones</h3>
      <p class="texto-principal">También cabe destacar otras transformaciones importantes aunque significativamente menores en volumen de energía:</p>
      <p class="texto-principal">La coquización es un proceso de transformación de carbón a coque obtenido mediante el calentado del carbón a temperaturas superiores a los 600 °C con el objetivo de eliminar componentes volátiles y producir un material duro, sólido y poroso, con altos contenidos de carbono. El coque es utilizado en baterías de hornos que pueden configurarse como tipo colmena, solera, pampa o de subproductos.	</p>
      <p class="texto-principal">Por su parte, las plantas de procesamiento de gas llevan a cabo un proceso de fraccionamiento de los condensados del gas natural para separar los hidrocarburos mezclados en él y así obtener productos individuales. Estos condensados incluyen etano, propano, n-butano, isobutano y los isómeros del pentano, así como la gasolina que se encuentra de manera natural en el gas.</p>
    </div>

    <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
      <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
      <ul class="lista-referencias">
        <li><strong><em>Palacios, R., Valles, X., Solís, A., Becerril, A. S., Rodríguez, F., Martínez, H., Rodríguez, J. I., De La Pascua, L. E., Pleitez, R. O., Hernández, F., & Zamudio, J. P. (2022).</em></strong> Estudio del Balance Nacional de Energía 2020. Consejo Nacional de Ciencia y Tecnología (Conacyt), Plataforma Nacional Energía Ambiente y Sociedad (Planeas), Programa Nacional Estratégico de Energía y Cambio Climático (Pronaces-ecc). <a href="https://conacyt.mx/publicaciones-conacyt/energia-y-cambio-climatico/" target="_blank">https://conacyt.mx/publicaciones-conacyt/energia-y-cambio-climatico/</a></li>
      </ul>            
    </div>

  </div>
</template>
<script>
  
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import am4lang_es_ES from "@amcharts/amcharts4/lang/es_ES";
  import am4themes_kelly from "@amcharts/amcharts4/themes/kelly";

  am4core.useTheme(am4themes_kelly);
  

  export default {
    name: 'App',
    components: {
      
    },
    data: function () {
      return {
        
      }   
    },
    mounted() {

      
      
      let chart = am4core.create(this.$refs.graficaRefinacion, am4charts.SankeyDiagram);
      chart.language.locale = am4lang_es_ES;
      chart.language.locale["_decimalSeparator"] = ".";
      chart.language.locale["_thousandSeparator"] = ",";
      chart.exporting.menu = new am4core.ExportMenu();
      chart.exporting.filePrefix = "TransformacionesPetroleo";
      chart.exporting.useWebFonts = false;
      
      chart.dataFields.fromName = "source";
      chart.dataFields.toName = "target";
      chart.dataFields.value = "value";
      chart.dataFields.color = "color";
      chart.paddingLeft = 10;
      chart.paddingRight = 80;

      chart.fontSize = 12;
      
      chart.data = [
            { source: "Petroleo", target: "Refinerías y\ndespuntadoras", value: 1303.1, color: "#000000"},
            { source: "Refinerías y\ndespuntadoras", target: "Coque de\npetróleo", value: 99.27, color: "#434343" },
            { source: "Refinerías y\ndespuntadoras", target: "Combus\n-tóleo", value:  417.32, color:"#666666" },
            { source: "Refinerías y\ndespuntadoras", target: "Queroseno", value: 36.83, color:"#999999"  },
            { source: "Refinerías y\ndespuntadoras", target: "Diésel", value: 220.49, color:"#b7b7b7"  },
            { source: "Refinerías y\ndespuntadoras", target: "Gasolina", value: 357.7, color:"#cccccc" },
            { source: "Refinerías y\ndespuntadoras", target: "GLP", value: 8.43, color:"#c9daf8" },
            { source: "Refinerías y\ndespuntadoras", target: "Gas seco", value: 76.64, color:"#6d9eeb" },
            { source: "Refinerías y\ndespuntadoras", target: "No energéticos", value: 29.4, color:"#ff00ff" },

      ];

      chart.nodes.template.draggable = true;
      chart.links.template.events.on("down", function (event) {
        var fromNode = event.target.dataItem.fromNode;
        var toNode = event.target.dataItem.toNode;

        var distanceToFromNode = am4core.math.getDistance(event.pointer.point, { x: fromNode.pixelX, y: fromNode.pixelY });
        var distanceToToNode = Infinity;
        if (toNode) {
          distanceToToNode = am4core.math.getDistance(event.pointer.point, { x: toNode.pixelX, y: toNode.pixelY });
        }

        if (distanceToFromNode < distanceToToNode) {
          fromNode.dragStart(event.pointer);
        }
        else {
          toNode.dragStart(event.pointer);
        }
      })

      this.chart = chart;

      let chart2 = am4core.create(this.$refs.graficaGeneracionElectrica, am4charts.SankeyDiagram);
      chart2.language.locale = am4lang_es_ES;
      chart2.language.locale["_decimalSeparator"] = ".";
      chart2.language.locale["_thousandSeparator"] = ","; 
      chart2.exporting.menu = new am4core.ExportMenu();
      chart2.exporting.filePrefix = "TransformacionesElectricidad";
      chart2.exporting.useWebFonts = false;
      chart2.dataFields.fromName = "source";
      chart2.dataFields.toName = "target";
      chart2.dataFields.value = "value";
      chart2.dataFields.color = "color";
      chart2.paddingLeft = 10;
      chart2.paddingRight = 80;

      chart2.fontSize = 12;
      
      chart2.data = [

            { source: "Coque de petróleo", target: "Centrales eléctricas", value: 37.84, color: "#434343" },
            { source: "Combustóleo", target: "Centrales eléctricas", value:  137.69, color:"#666666" },
            { source: "Diésel", target: "Centrales eléctricas", value:  24.32, color:"#b7b7b7" },
            { source: "Nucleoenergía", target: "Centrales eléctricas", value: 125.62, color:"#9900ff"  },
            { source: "Gas seco", target: "Centrales eléctricas", value: 1438.99, color:"#6d9eeb" },
            { source: "Geoenergía", target: "Centrales eléctricas", value: 18.54, color:"#783f04" },
            { source: "Energía eólica", target: "Centrales eléctricas", value: 70.9, color:"#0000ff" },
            { source: "Hidroenergía", target: "Centrales eléctricas", value: 96.52, color:"#00ffff" },
            { source: "Bagazo de caña", target: "Centrales eléctricas", value: 57.82, color:"#f6b26b" },
            { source: "Biogás", target: "Centrales eléctricas", value: 2.53, color:"#6d9eeb" },
            { source: "Energía solar", target: "Centrales eléctricas", value: 56.48, color:"#ffff00" },
            { source: "Carbón", target: "Centrales eléctricas", value: 164.10, color:"#cc4125" },
            { source: "Centrales eléctricas", target: "Generación eléctrica", value: 1186.9, color:"#00ff00" },
            
            { source: "Importación", target: "Generación eléctrica", value: 35.87, color:"#00ff99" },
            
            { source: "Generación eléctrica", target: "Pérdidas en\ntransmisión y\ndistribución", value: 199.62, color:"#F00" },
            { source: "Generación eléctrica", target: "Residencial", value: 248.32, color:"#BAF345" },
            { source: "Generación eléctrica", target: "Público", value: 14.26, color:"#333555" },
            { source: "Generación eléctrica", target: "Comercial", value: 49.48, color:"#c9daf8" },
            { source: "Generación eléctrica", target: "Transporte", value: 3.41, color:"#666666" },
            { source: "Generación eléctrica", target: "Agropecuario", value: 50.43, color:"#b7b7b7" },
            { source: "Generación eléctrica", target: "Industrial", value: 635.85, color:"#85200c" },
            { source: "Centrales eléctricas", target: "Pérdidas por\ntransformación", value: 1044.5, color:"#f9a145"},

      ];

      chart2.events.on('datavalidated', function() {
          
          chart2.nodes.getKey('Pérdidas por\ntransformación').level = 3;
      })

      chart2.nodes.template.draggable = true;
      chart2.links.template.events.on("down", function (event) {
        var fromNode = event.target.dataItem.fromNode;
        var toNode = event.target.dataItem.toNode;

        var distanceToFromNode = am4core.math.getDistance(event.pointer.point, { x: fromNode.pixelX, y: fromNode.pixelY });
        var distanceToToNode = Infinity;
        if (toNode) {
          distanceToToNode = am4core.math.getDistance(event.pointer.point, { x: toNode.pixelX, y: toNode.pixelY });
        }

        if (distanceToFromNode < distanceToToNode) {
          fromNode.dragStart(event.pointer);
        }
        else {
          toNode.dragStart(event.pointer);
        }
      })

      this.chart2 = chart2;

    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose();
      }

      if (this.chart2) {
        this.chart2.dispose();
      }
    },
  }

</script>
<style scoped lang="scss">

  .graficaRefinacion {
    width: 100%;
    height: 500px;
  }

  .graficaGeneracionElectrica {
    width: 100%;
    height: 500px;
  }

</style>
